import { createSlice } from "@reduxjs/toolkit"
import {
  addConstituentDonation,
  addUserDonation,
  checkAuthorizeStripeThunk,
  deleteConstituentDonation,
  deleteUserDonation,
  delinkStripeThunk,
  editConstituentDonation,
  editUserDonation,
} from "./thunks"

export type DonationsAdminState = {
  loading: boolean
  integrationUrl: string
  integrationError: string
}

const initialState: DonationsAdminState = {
  loading: false,
  integrationUrl: "",
  integrationError: "",
}

const donationsAdminSlice = createSlice({
  initialState,
  name: "donations/admin",
  reducers: {
    clearError: (state) => {
      state.integrationError = ""
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkAuthorizeStripeThunk.pending, (state) => {
        state.loading = true
      })
      .addCase(checkAuthorizeStripeThunk.fulfilled, (state, action) => {
        state.loading = false
        state.integrationError = ""
        state.integrationUrl = action.payload?.url ?? ""
      })
      .addCase(checkAuthorizeStripeThunk.rejected, (state, action) => {
        state.loading = false
        state.integrationError = action.error.message || "Failed to authorize Stripe"
        state.integrationUrl = ""
      })
      .addCase(delinkStripeThunk.pending, (state) => {
        state.loading = true
      })
      .addCase(delinkStripeThunk.fulfilled, (state) => {
        state.loading = false
      })
      .addCase(delinkStripeThunk.rejected, (state) => {
        state.loading = false
      })

    // // Delete User Donation
    // .addCase(deleteUserDonation.pending, (state) => {
    //   state.loading = true
    // })
    // .addCase(deleteUserDonation.fulfilled, (state, action) => {
    //   state.loading = false
    // })
    // .addCase(deleteUserDonation.rejected, (state, action) => {
    //   state.loading = false
    // })
    //
    // // Edit User Donation
    // .addCase(editUserDonation.pending, (state) => {
    //   state.loading = true
    // })
    // .addCase(editUserDonation.fulfilled, (state, action) => {
    //   state.loading = false
    // })
    // .addCase(editUserDonation.rejected, (state, action) => {
    //   state.loading = false
    // })
    //
    // // Add User Donation
    // .addCase(addUserDonation.pending, (state) => {
    //   state.loading = true
    // })
    // .addCase(addUserDonation.fulfilled, (state, action) => {
    //   state.loading = false
    // })
    // .addCase(addUserDonation.rejected, (state, action) => {
    //   state.loading = false
    // })
    //
    // // Edit Constituent Donation
    // .addCase(editConstituentDonation.pending, (state) => {
    //   state.loading = true
    // })
    // .addCase(editConstituentDonation.fulfilled, (state, action) => {
    //   state.loading = false
    // })
    // .addCase(editConstituentDonation.rejected, (state, action) => {
    //   state.loading = false
    // })
    //
    // // Delete Constituent Donation
    // .addCase(deleteConstituentDonation.pending, (state) => {
    //   state.loading = true
    // })
    // .addCase(deleteConstituentDonation.fulfilled, (state, action) => {
    //   state.loading = false
    // })
    // .addCase(deleteConstituentDonation.rejected, (state, action) => {
    //   state.loading = false
    // })
    //
    // // Add Constituent Donation
    // .addCase(addConstituentDonation.pending, (state) => {
    //   state.loading = true
    // })
    // .addCase(addConstituentDonation.fulfilled, (state, action) => {
    //   state.loading = false
    // })
    // .addCase(addConstituentDonation.rejected, (state, action) => {
    //   state.loading = false
    // })
  },
})

export const DonationAdminActions = {
  ...donationsAdminSlice.actions,
  checkAuthorizeStripe: checkAuthorizeStripeThunk,
  delinkStripe: delinkStripeThunk,
  deleteUserDonation,
  editUserDonation,
  addUserDonation,
  editConstituentDonation,
  deleteConstituentDonation,
  addConstituentDonation,
}

export default donationsAdminSlice.reducer
